export const generateAuthorizationHeaders = (
  token: string
): Record<string, string> => {
  return {
    Authorization: `Bearer ${token}`,
  };
};
